<div class="ui basic segment">
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div style="margin: -10px -30px" class="ui vertical basic segment">
    <app-advanced-search-filter
      (onDisplayRows)="displayRecords($event)"
      (onSearch)="searchRecords($event)"
      [hasAdvancedSearch]="true"
      [headers]="headers"
      [headerFilters]="headerFilters"
      [hasFilters]="true"
      (onSort)="sortRecords($event)"
      [searchFilters]="searchFilter"
      (advancedSearch)="advancedSearch($event)"
      (cancelAd)="cancelAd()"
    ></app-advanced-search-filter>
  </div>
  <div
    style="margin: -10px -30px"
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
  >
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="15%">IP Address</div>
      <div fxFlex="30">Host Name</div>
      <div fxFlex="20">Username</div>
      <div fxFlex="25%" fxFlex>Email Address</div>

      <div fxFlex="10"></div>
    </div>
    <ng-container *ngFor="let user of users">
      <div
        class="ui segment"
        appMargin
        marginB="3"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="15%">{{ user?.metadata?.lastIp }}</div>
        <div fxFlex="30">{{ user?.metadata?.lastAgent }}</div>
        <div fxFlex="20">{{ user?.user?.username }}</div>
        <div fxFlex="25%" fxFlex>{{ user?.user?.appUserEmail }}</div>

        <div fxFlex="10">
          <div class="ui circular button">
            <i (click)="viewUser(user)" class="eye icon"></i>
          </div>
        </div>
      </div>
    </ng-container>
    <app-no-record-found
      *ngIf="users && users.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
